import { useTranslation } from 'react-i18next'

import { PageEmptyState } from '../../../../../PageEmptyState'

import UsersIcon from '../../../../../../icons/users-1.svg'

function ListingProfileApplicantsEmpty() {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={UsersIcon}
      text={t('RentalPortal.ListingProfileApplicantsEmptyKey')}
    />
  )
}

export default ListingProfileApplicantsEmpty
